import { catchError, map, tap, Observable, of } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { environment } from '../../../../environment/environment';

export function educationalPathVersions(componentDataSourceService: ComponentDataSourceService) {
  return {
    name: 'Educational Path Versions',
    description: 'Lists all versions for a specific educational path',
    execute: () => {
      
      // Get the UUID from the URL
      const currentUrl = window.location.pathname;
      const parts = currentUrl.split('/').filter(Boolean);
      const uddannelsesvejIndex = parts.indexOf('uddannelsesvej');
      
      if (uddannelsesvejIndex === -1 || !parts[uddannelsesvejIndex + 1]) {
        console.warn('No UUID found in URL');
        return of([]);
      }

      const uuid = parts[uddannelsesvejIndex + 1];
      
      return componentDataSourceService.http.get(`${environment.apiUrl}/paths/${uuid}/versions`).pipe(
        tap(result => {
        }),
        catchError(error => {
          console.error('Error fetching educational path versions:', error);
          return of(null);
        }),
        map((result: any) => {
          if (!result) {
            return [];
          }

          var transformedData = result.map((version: any) => {
            return {
              ...version,
              display_name: version.name
            }
          });
          
          
          return transformedData;
        })
      );
    },
    settings: {
      columns: [
        { key: 'id', header: 'ID', type: 'number' },
        { key: 'name', header: 'Navn', type: 'text' },
        { key: 'created_at', header: 'Oprettet', type: 'date' },
        { key: 'updated_at', header: 'Opdateret', type: 'date' },
        { key: 'visibility', header: 'Synlighed', type: 'text' }
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      defaultSortColumn: 'created_at',
      defaultSortDirection: 'desc'
    }
  }
} 